import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import { UseOutletContextCategory } from './Category';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { CategoryDA } from '../../../../services/admin/category.service';
import { Error } from '../../../../models/error.model';
import { Message } from '../../../../models/message.model';
import { CompanyCategories } from '../../../../models/company.categories.model';
import { GlobalSwal } from '../../../../styles/swal.style';
import { Category } from '../../../../models/category.model';
import { modalShow } from '../../../../utils/modal.util';
import { getError, getMessage } from '../../../../languages/translations/response';
import { sortColumn } from '../../../../scripts/table.script';
import { errorWebHandler } from '../../../../scripts/error.web.handler.script';

import AppModalCategoryCreate from '../../../../components/modal/ModalCategoryCreate';
import AppModalCategoryUpdate from '../../../../components/modal/ModalCategoryUpdate';
import AppPagination from '../../../../components/element/Pagination';
import AppPreloader from '../../../../components/Preloader';
import AppSortTable from '../../../../components/element/SortTable';
import AppInventoryListHeader from '../component/InventoryListHeader';

export interface CategoryListPageProps {};

let errorResponse: Error, messageResponse: Message, categoryResponse: Category, categoriesResponse: CompanyCategories;

const CategoryListPage: React.FunctionComponent<CategoryListPageProps> = props => {
  const {setRoute, companyForUser, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, setCategoriesForCompany} = UseOutletContextCategory()
  const {lang} = StateLanguage()

  const [mounted, setMounted] = useState(false)
  const [filter, setFilter] = useState({search: '', options: {sort_field: '', sort_mode: ''}})
  const [checked, setChecked] = useState({count: 0, list: [] as string[]})
  const [pagination, setPagination] = useState({current: 1, total: 0, pages: 1, limit: 20})
  const [categories, setCategories] = useState<Category[] | null>(null)
  const [category, setCategory] = useState<Category | null>(null)

  const loadCategories = async (id_company: string, callback: any, page: number = 1, limit: number = pagination.limit) => {
    await CategoryDA.getCategories(id_company, filter.search, filter.options.sort_field, filter.options.sort_mode, page, limit).then( (response) => {
      if (response.status === 200) {
        categoriesResponse = response.data?.data ?? response.data
        const categoryItems = categoriesResponse.items ?? categoriesResponse.categories ?? []
        const pg = categoriesResponse.pagination ?? { page, limit: pagination.limit, total: categoryItems.length, pages: 1 }

        setCategories(categoryItems)
        setChecked({count: 0, list: []})
        setPagination({current: pg.page ?? page, total: pg.total ?? categoryItems.length, pages: pg.pages ?? 1, limit: pg.limit ?? pagination.limit})
        callback()
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  const handleChangePage = (page: number, newLimit?: number) => {
    if (companyForUser) loadCategories(companyForUser.id, () => {}, page, newLimit ?? pagination.limit)
  }

  const submitCategoryUpdate = async (item: string) => {
    modalShow('modal-category-update')

    if (companyForUser) {
      await CategoryDA.getCategory(companyForUser.id, item).then( (response) => {
        if (response.status === 200) {
          categoryResponse = response.data?.data ?? response.data
          setCategory(categoryResponse)
        } else {
          errorResponse = response.data

          GlobalSwal.fire({
            title: getError(errorResponse.code, lang.code, errorResponse.message),
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: 'error',
            confirmButtonText: lang.labels.okGotIt
          })
        }
      }).catch( (error) => {
        errorWebHandler(lang, error)
      })
    }
  }

  const submitCategoryDelete = async (item: string) => {
    if (companyForUser && categoriesForCompany) {
      GlobalSwal.fire({
        title: lang.labels.youWantToDeleteThisCategory,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await CategoryDA.deleteCategories(companyForUser.id, [item]).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadCategories(companyForUser.id, () => {
                setCategoriesForCompany(categoriesForCompany.filter((temp) => (temp.id !== item)))

                GlobalSwal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2200
                })
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch( (error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
  }

  const handleChangeSelectAllCategories = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let list: string[] = (event.target.checked) ? event.target.value.split(',') : []
    setChecked({...checked, count: list.length, list: list})
  }

  const handleChangeSelectCategory = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let list: string[] = (event.target.checked) ? (!checked.list.includes(event.target.value)) ? checked.list.concat(event.target.value) : checked.list : checked.list.filter((item) => (item !== event.target.value))
    setChecked({...checked, count: list.length, list: list})
  }

  const executeSortList = (item: string) => {
    if (companyForUser) {
      sortColumn(item, filter.options)
      setFilter({search: filter.search, options: {...filter.options}})
      loadCategories(companyForUser.id, () => {})
    }
  }

  function quantityAssets(quantity: number): string {
    return (quantity > 0) ? 'success' : 'danger'
  }

  useEffect( () => {
    if (companyForUser) {
      filter.search = ''
      filter.options.sort_field = ''
      filter.options.sort_mode = ''
      setFilter({search: '', options: {sort_field: '', sort_mode: ''}})
      setChecked({count: 0, list: []})

      setCategories(null)
      loadCategories(companyForUser.id, () => {})
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser])

  useEffect( () => {
    setMounted(true)
    setRoute({path: {root: lang.labels.categories, branch: lang.labels.listCategories}, company: true})

    return () => setMounted(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!mounted) return null

  return (
    <div className="w-100 h-100">
      { categories
        ?
        <div className="card card-flush">
          <AppInventoryListHeader inventory={"category"} filter={filter} setFilter={setFilter} checked={checked} loadInventory={loadCategories}></AppInventoryListHeader>
          <div className="card-body pt-0">
            <div className="dataTables_wrapper">
              <div className="table-responsive">
                <table className="table align-middle table-row-dashed mb-2">
                  <thead className="border-bottom">
                    <tr className="text-start text-muted text-uppercase fw-bolder fs-7">
                      <th className="w-25px">
                        <div className="form-check form-check-sm form-check-custom form-check-solid">
                          <input className="form-check-input" type="checkbox" value={categories.map(item => item.id)} checked={categories.length === checked.count && checked.count > 0} onChange={handleChangeSelectAllCategories} />
                        </div>
                      </th>
                      <th className="min-w-350px">
                        <div className="d-flex align-items-center text-nowrap cursor-pointer" onClick={() => executeSortList("category")}>
                          <span className="me-1">{lang.labels.category}</span>
                          <AppSortTable attribute={"category"} field={filter.options.sort_field} mode={filter.options.sort_mode}></AppSortTable>
                        </div>
                      </th>
                      <th className="w-125px">
                        <div className="d-flex align-items-center text-nowrap cursor-pointer" onClick={() => executeSortList("services")}>
                          <span className="me-1">{lang.labels.qtyServices}</span>
                          <AppSortTable attribute={"services"} field={filter.options.sort_field} mode={filter.options.sort_mode}></AppSortTable>
                        </div>
                      </th>
                      <th className="w-125px">
                        <div className="d-flex align-items-center text-nowrap cursor-pointer" onClick={() => executeSortList("products")}>
                          <span className="me-1">{lang.labels.qtyProducts}</span>
                          <AppSortTable attribute={"products"} field={filter.options.sort_field} mode={filter.options.sort_mode}></AppSortTable>
                        </div>
                      </th>
                      <th className="w-100px text-end">{lang.labels.actions}</th>
                    </tr>
                  </thead>
                  { categories.length > 0
                    ?
                    <tbody className="text-secondary fw-bold">
                      { categories.map (( (item, index) => { return (
                        <tr key={index} className="row-dashed">
                          <td>
                            <div className="form-check form-check-sm form-check-custom form-check-solid">
                              <input className="form-check-input" type="checkbox" value={item.id} checked={checked.list.includes(item.id)} onChange={handleChangeSelectCategory} />
                            </div>
                          </td>
                          <td className="d-flex flex-column">
                            <Link to={"/main/inventory/category/view/" + item.id} className="fw-bolder text-dark text-capitalize text-hover-primary mb-1">{item.display_name}</Link>
                            <small>{item.description}</small>
                          </td >
                          <td className={`text-${quantityAssets(item.services?.length ?? 0)} text-center fw-bolder`}>{item.services?.length ?? 0}</td>
                          <td className={`text-${quantityAssets(item.products?.length ?? 0)} text-center fw-bolder`}>{item.products?.length ?? 0}</td>
                          <td className="text-end">
                            <Dropdown>
                              <Dropdown.Toggle variant="btn btn-sm btn-light btn-active-light-primary">
                                <div className="d-flex align-items-center">
                                  {lang.labels.actions}
                                  <span className="svg-icon svg-icon-5 me-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black"></path>
                                    </svg>
                                  </span>
                                </div>
                              </Dropdown.Toggle>
                              <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }} variant="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto p-3 fs-7" align="end">
                                <Dropdown.Item bsPrefix="menu-item" onClick={() => submitCategoryUpdate(item.id)}>
                                  <p className="menu-link fw-bold px-3 py-1 m-0">{lang.labels.edit}</p>
                                </Dropdown.Item>
                                <Dropdown.Item bsPrefix="menu-item" onClick={() => submitCategoryDelete(item.id)}>
                                  <p className="menu-link fw-bold px-3 py-1 m-0">{lang.labels.delete}</p>
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )}))}
                    </tbody>
                    :
                    <tbody>
                      <tr className="text-secondary fw-bold">
                        <td colSpan={5} className="text-center">{lang.labels.noRecordsFound}</td>
                      </tr>
                    </tbody>
                  }
                </table>
              </div>
              <AppPagination
                showOption={true}
                pagination={{
                  current: pagination.current,
                  total: pagination.total,
                  limit: pagination.limit,
                  pages: Array.from({ length: pagination.pages }, (_, i) => i + 1),
                }}
                loadPagination={handleChangePage}
              ></AppPagination>
            </div>
          </div>
        </div>
        :
        <AppPreloader></AppPreloader>
      }
      <AppModalCategoryCreate companyForUser={companyForUser} categoriesForCompany={categoriesForCompany} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accountingIncomeAccountsForCompany={accountingIncomeAccountsForCompany} categories={categories} setCategoriesForCompany={setCategoriesForCompany} setCategories={setCategories}></AppModalCategoryCreate>
      <AppModalCategoryUpdate companyForUser={companyForUser} categoriesForCompany={categoriesForCompany} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accountingIncomeAccountsForCompany={accountingIncomeAccountsForCompany} category={category} categories={categories} setCategoriesForCompany={setCategoriesForCompany} setCategory={setCategory} setCategories={setCategories}></AppModalCategoryUpdate>
    </div>
  )
};

export default CategoryListPage;
